<template>
  <div class="bg_white mt25">
    <Pageback :backLinkName="'fanClubSummitMemberList'" />
    <div class="wrap">
      <div class="head-content">
        <div class="thumbnail"><img v-on:error="imgLoad(imageSrc1, 'imageSrc1')" :src="imageSrc1" alt=""></div>
        <div class="post-title">
          <h1>{{ title }}</h1>
        </div>
      </div>
      <div class="container">
        <p v-html="description">{{ description }}</p>
        <p><img v-on:error="imgLoad(imageSrc2, 'imageSrc2')" :src="imageSrc2" alt=""></p>
        <p><img v-on:error="imgLoad(imageSrc3, 'imageSrc3')" :src="imageSrc3" alt=""></p>
      </div>
    </div>
  </div>
</template>

<script>
import Summit from '@/components/api/summit'
import checkImg from '@/model/imgLoad'
import Pageback from '@/components/common/Pageback';

export default {
  components: {
    Pageback
  },
  data() {
    return {
      // html: '<div class="wrap"><div class="head-content"><div class="thumbnail"><img src="../assets/img/thumb.png" alt=""></div><div class="post-title"><h1>10ミリオネア 青野 美奈子</h1></div><div class="post-date"><img src="../assets/img/icon-time.png" alt=""><p>2019/5/28 00:00</p></div></div><div class="container"><p>ブティック経営をしている32歳のときに高校時代のクラスメートからナチュラリープラスが伝わりました。未経験のビジネスで不安しかありませんでしたが、会社、商品、システム、系列を超えた先駆者たちに助けられ多くの仲間ができました。2003年から台湾への展開にチャレンジし、沢山の仲間に恵まれ、マレーシアや憧れていた国々でのリゾートを楽しむなど、夢を叶えることが出来ました。自由の無い、不安定な生活から解放され、好きなことを好きな時に好きな場所で好きなだけ楽しめる、 豊かな人生が手に入りました。<br>仲間と共に理想を現実にできるナチュラリープラスの全てに感謝します。</p><p><img src="assets/img/img1.png" alt=""></p><p><img src="assets/img/img2.png" alt=""></p></div></div>',
      description: '',
      imageSrc1: '',
      imageSrc2: '',
      imageSrc3: '',
      title: '',
    }
  },
  methods: {
    imgLoad(imageSrc, name) {
      let res = checkImg.checkImgSrc(imageSrc);
      if(name == 'imageSrc1') {
        this.imageSrc1 = res;
      } else if(name == 'imageSrc2') {
        this.imageSrc2 = res;
      } else {
        this.imageSrc3 = res;
      }
      // return res;
    },
    async apiGetDetail(id) {
      await Summit.getDetail(id).then((val) => {
        console.log(val);
        this.description = val.description;
        this.imageSrc1 = val.imageSrc1;
        this.imageSrc2 = val.imageSrc2;
        this.imageSrc3 = val.imageSrc3;
        this.title = val.title;
      });
    }
  },
  created() {
    this.apiGetDetail(this.$route.query.id);
  }
}
</script>

<style lang="css" scoped>

/* ----------------------
共通
------------------------- */
body{
  font-size: 14px;
}

/* 改行用 */
>>> .br768on{
  display:none;
}
>>> .br480on{
  display:none;
}
>>> .br375on{
  display:none;
}

/* レスポンシブ時の切り替え用 */
>>> .sp768on{
  display:none;
}
>>> .sp480on{
  display:none;
}
>>> .sp375on{
  display:none;
}
@media screen and (max-width:768px){
  >>> .br768off{
    display:none;
  }
  >>> .sp768off{
    display:none;
  }
  >>> .br768on{
    display:block;
  }
  >>> .sp768on{
    display:block;
  }
}
@media screen and (max-width:480px){
  >>> .br480off{
    display:none;
  }
  >>> .sp480off{
    display:none;
  }
  >>> .br480on{
    display:block;
  }
  >>> .sp480on{
    display:block;
  }
}
@media screen and (max-width:375px){
  >>> .br375off{
    display:none;
  }
  >>> .sp375off{
    display:none;
  }
  >>> .br375on{
    display:block;
  }
  >>> .sp375on{
    display:block;
  }
}

>>> .head-content {
  margin-bottom: 30px;
}

>>> .head-content .thumbnail{
  margin-bottom: 20px;
  text-align: center;
}

>>> .head-content .post-title,
.head-content .post-date{
  padding: 0 20px;
}

>>> .head-content >>> .post-title{
  font-size: 6vw;
  margin-bottom: 10px;
}

@media (min-width:641px){
  >>> .head-content .post-title{
    font-size: 40px;
  }
}

>>> .head-content .post-date{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #c1c1c1;
  font-size: 12px;
}

>>> .head-content .post-date img{
  max-width: 15px;
  margin-right: 5px;
}

>>> .container{
  padding: 0 20px;
}

>>> .container p{
  font-size: 16px;
  margin: 25px 0;
  line-height: 1.8;
  text-align: justify;
}

</style>



// WEBPACK FOOTER //
// src/views/fanClub/summitMember/SummitMember.vue